import { render, staticRenderFns } from "./Secession.vue?vue&type=template&id=2e9cfae5&scoped=true"
import script from "./Secession.vue?vue&type=script&lang=js"
export * from "./Secession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9cfae5",
  null
  
)

export default component.exports